import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type CommunityItem = {
  __typename?: 'CommunityItem';
  buttonLabel: Scalars['String'];
  graphicAlt?: Maybe<Scalars['String']>;
  graphicImageUrl?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  iconAlt: Scalars['String'];
  iconImageUrl: Scalars['String'];
  link: Scalars['String'];
  subheading: Scalars['String'];
};

export type CommunityTab = {
  __typename?: 'CommunityTab';
  communityItems?: Maybe<Array<Maybe<CommunityItem>>>;
  mainImageUrl?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  accessCode: Scalars['ID'];
  communityTab?: Maybe<CommunityTab>;
  date?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventState: EventState;
  mainAudio?: Maybe<Scalars['String']>;
  mainVideo?: Maybe<Scalars['String']>;
  perspectives: Array<Perspective>;
  sponsorship?: Maybe<Sponsorship>;
  time?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EventInput = {
  accessCode: Scalars['ID'];
  perspectives: Array<PerspectiveInput>;
  title: Scalars['String'];
};

export enum EventState {
  Disabled = 'DISABLED',
  Ended = 'ENDED',
  Live = 'LIVE',
  NotStarted = 'NOT_STARTED'
}

export type EventUpdate = {
  __typename?: 'EventUpdate';
  accessCode: Scalars['ID'];
  eventState?: Maybe<EventState>;
  title?: Maybe<Scalars['String']>;
};

export type EventUpdateInput = {
  eventState?: InputMaybe<EventState>;
  title?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  updateEvent: EventUpdate;
  updatePerspective: PerspectiveUpdate;
};


export type MutationUpdateEventArgs = {
  accessCode: Scalars['ID'];
  update: EventUpdateInput;
};


export type MutationUpdatePerspectiveArgs = {
  accessCode: Scalars['ID'];
  id: Scalars['ID'];
  update: UpdatePerspectiveInput;
};

export type Perspective = {
  __typename?: 'Perspective';
  id: Scalars['ID'];
  order: Scalars['Int'];
  perspectiveState: PerspectiveState;
  playbackId: Scalars['String'];
  sponsorship?: Maybe<Sponsorship>;
  streamKey: Scalars['String'];
  title: Scalars['String'];
  vodPlaybacks?: Maybe<Array<VodPlayback>>;
};

export type PerspectiveInput = {
  title: Scalars['String'];
};

export enum PerspectiveState {
  Live = 'LIVE',
  Offline = 'OFFLINE'
}

export type PerspectiveUpdate = {
  __typename?: 'PerspectiveUpdate';
  accessCode: Scalars['ID'];
  id: Scalars['ID'];
  perspectiveState?: Maybe<PerspectiveState>;
  vodPlaybacks?: Maybe<Array<VodPlayback>>;
};

export type Query = {
  __typename?: 'Query';
  getEvent: Event;
  getEventsByTime: Array<Event>;
};


export type QueryGetEventArgs = {
  accessCode: Scalars['ID'];
};

export type Sponsorship = {
  __typename?: 'Sponsorship';
  logo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onEventUpdate?: Maybe<EventUpdate>;
  onPerspectiveUpdate?: Maybe<PerspectiveUpdate>;
};


export type SubscriptionOnEventUpdateArgs = {
  accessCode: Scalars['ID'];
};


export type SubscriptionOnPerspectiveUpdateArgs = {
  accessCode: Scalars['ID'];
};

export type UpdatePerspectiveInput = {
  perspectiveState?: InputMaybe<PerspectiveState>;
  vodPlayback?: InputMaybe<Array<VodPlaybackInput>>;
};

export type VodPlayback = {
  __typename?: 'VodPlayback';
  id: Scalars['String'];
  startedAt: Scalars['String'];
  videoLength?: Maybe<Scalars['String']>;
};

export type VodPlaybackInput = {
  id?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  videoLength?: InputMaybe<Scalars['String']>;
};

export type EventQueryVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type EventQuery = { __typename?: 'Query', getEvent: { __typename?: 'Event', title: string, eventState: EventState, mainAudio?: string | null, mainVideo?: string | null, sponsorship?: { __typename?: 'Sponsorship', logo?: string | null, title?: string | null } | null, perspectives: Array<{ __typename?: 'Perspective', id: string, order: number, title: string, perspectiveState: PerspectiveState, playbackId: string, sponsorship?: { __typename?: 'Sponsorship', logo?: string | null, title?: string | null } | null, vodPlaybacks?: Array<{ __typename?: 'VodPlayback', id: string, startedAt: string, videoLength?: string | null }> | null }>, communityTab?: { __typename?: 'CommunityTab', mainImageUrl?: string | null, communityItems?: Array<{ __typename?: 'CommunityItem', heading: string, iconImageUrl: string, iconAlt: string, link: string, buttonLabel: string, graphicAlt?: string | null, graphicImageUrl?: string | null } | null> | null } | null } };

export type GetDateTimeQueryVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type GetDateTimeQuery = { __typename?: 'Query', getEvent: { __typename?: 'Event', accessCode: string, title: string, date?: string | null, time?: string | null, timezone?: string | null } };

export type EventUpdatesSubscriptionVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type EventUpdatesSubscription = { __typename?: 'Subscription', onEventUpdate?: { __typename?: 'EventUpdate', title?: string | null, eventState?: EventState | null } | null };

export type PerspectiveUpdatesSubscriptionVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type PerspectiveUpdatesSubscription = { __typename?: 'Subscription', onPerspectiveUpdate?: { __typename?: 'PerspectiveUpdate', id: string, perspectiveState?: PerspectiveState | null } | null };

export type CheckEventQueryVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type CheckEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'Event', accessCode: string, eventState: EventState } };


export const EventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Event"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventState"}},{"kind":"Field","name":{"kind":"Name","value":"mainAudio"}},{"kind":"Field","name":{"kind":"Name","value":"mainVideo"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perspectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"perspectiveState"}},{"kind":"Field","name":{"kind":"Name","value":"playbackId"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vodPlaybacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"videoLength"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"communityTab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"communityItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"iconImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"iconAlt"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"graphicAlt"}},{"kind":"Field","name":{"kind":"Name","value":"graphicImageUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const GetDateTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDateTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetDateTimeQuery, GetDateTimeQueryVariables>;
export const EventUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"EventUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onEventUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventState"}}]}}]}}]} as unknown as DocumentNode<EventUpdatesSubscription, EventUpdatesSubscriptionVariables>;
export const PerspectiveUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PerspectiveUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onPerspectiveUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"perspectiveState"}}]}}]}}]} as unknown as DocumentNode<PerspectiveUpdatesSubscription, PerspectiveUpdatesSubscriptionVariables>;
export const CheckEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessCode"}},{"kind":"Field","name":{"kind":"Name","value":"eventState"}}]}}]}}]} as unknown as DocumentNode<CheckEventQuery, CheckEventQueryVariables>;